/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Problem_OverlineInputs */

const en_mk_problem_overline = /** @type {(inputs: Mk_Problem_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The real problem`)
};

const id_mk_problem_overline = /** @type {(inputs: Mk_Problem_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masalah yang nyata`)
};

/**
* | output |
* | --- |
* | "The real problem" |
*
* @param {Mk_Problem_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_problem_overline = /** @type {((inputs?: Mk_Problem_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Problem_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_problem_overline(inputs)
	return en_mk_problem_overline(inputs)
});